// extracted by mini-css-extract-plugin
export default {"pingHeader":"pingHeader_pingHeader__JPdX3","ping":"pingHeader_ping__vrWVi","inner":"pingHeader_inner__rtspp"};